import React from 'react';
import { connect } from 'react-redux'
import _ from "lodash";
import { useNavigate } from 'react-router-dom';

// components
import TicketDetails from '../activeTicket/TicketDetails';
import CustomerDetails from '../activeTicket/CustomerDetails';
import { PubSubKeys, TicketStatuses } from '../../../../store/constants';
import { completeTicket } from '../../../../store/actions/ticketsActions';
import { modalUpdate } from '../../../../store/actions/settingsActions';

function ReQueueTicket(props) {
    const navigate = useNavigate();
    const {
        activeTicketId,
        customers,
        hostname,
        tickets,
    } = props;

    const ticket = tickets.find(data => data.id === activeTicketId);
    const customer = ticket ? customers.find(data => data.mobileNumber === ticket.mobileNumber) : null;

    const submitReQueue = () => {
        if (ticket == null || activeTicketId == null) {
            return;
        }

        const reQueuedTicket = _.cloneDeep(ticket);
        reQueuedTicket.status = TicketStatuses.transferTicket;
        delete reQueuedTicket.manage;

        const payload = {
            ...PubSubKeys.transferTicket,
            msg: {
                ticket: reQueuedTicket,
            },
        };

        props.completeTicket(hostname, payload);
        props.modalUpdate({ visible: 0, content: null, modalType: 0 });
        navigate('/queuing/tickets/');
    };

    if (!ticket) {
        return <h5>No active ticket selected</h5>;
    }

    return (
        <div className="home-center-content1 home-center-content3">
            <h5>Re-Queue Ticket</h5>
            <div className="informationContainer requeueInformation">
                <div className="informationRow">
                    <label>Action</label>
                    <span>Return this ticket to the waiting queue</span>
                </div>
                <div className="informationRow">
                    <label>Service</label>
                    <span>The ticket stays on the same service</span>
                </div>
                <div className="informationRow">
                    <label>Agent assignment</label>
                    <span>Your agent and counter assignment will be removed</span>
                </div>
            </div>
            <div className="home-right-content2-bottom">
                <TicketDetails ticket={ticket} />
                <CustomerDetails ticket={ticket} customer={customer} />
            </div>
            <div className="form-submit-btn" onClick={submitReQueue}>Yes, re-queue ticket</div>
        </div>
    );
}

const mapStateToProps = state => {
    const { auth, customers, tickets, services, sessions } = state
    return {
        tickets: tickets.tickets,
        activeTicketId: tickets.activeTicketId,
        customers: customers.customers,
        hostname: auth.hostname,
        supportDesks: services.supportDesks,
        sessions: sessions.sessions,
        authenticatedUser: auth.authenticatedUser,
    }
}

export default connect(mapStateToProps, {
    completeTicket,
    modalUpdate,
})(ReQueueTicket)
